import { render } from "./background-tasks-indicator.vue?vue&type=template&id=3277e32e&ts=true"
import script from "./background-tasks-indicator.vue?vue&type=script&lang=ts"
export * from "./background-tasks-indicator.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__